import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import HomePage from "@/home/HomePage";
import AboutPage from "@/pages/AboutPage";
import PortfolioPage from "@/pages/PortfolioPage";
import DistributionPage from "@/pages/DistributionPage";
import InfrastructurePage from "@/pages/InfrastructurePage";
import NonAlcoPage from "@/pages/NonAlcoPage";
import PartnerPage from "@/pages/PartnerPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminBrands from "@/pages/admin/AdminBrands";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminRegions from "@/pages/admin/AdminRegions";
import AdminStatistics from "@/pages/admin/AdminStatistics";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        {/* Admin console — outside the public site layout (no age gate / header) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminEnquiries />} />
          <Route path="brands" element={<AdminBrands />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="regions" element={<AdminRegions />} />
          <Route path="statistics" element={<AdminStatistics />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* Public website */}
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/distribution" element={<DistributionPage />} />
                <Route path="/infrastructure" element={<InfrastructurePage />} />
                <Route path="/non-alcoholic-fmcg" element={<NonAlcoPage />} />
                <Route path="/partner" element={<PartnerPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/legal/:slug" element={<LegalPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
